import { render, staticRenderFns } from "./CustomerManagement.vue?vue&type=template&id=3c694046&scoped=true"
import script from "./CustomerManagement.vue?vue&type=script&lang=js"
export * from "./CustomerManagement.vue?vue&type=script&lang=js"
import style0 from "./CustomerManagement.vue?vue&type=style&index=0&id=3c694046&prod&scoped=true&lang=css"
import style1 from "./CustomerManagement.vue?vue&type=style&index=1&id=3c694046&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c694046",
  null
  
)

export default component.exports